import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: 'table-sorting',
  templateUrl: './table-sorting.component.html',
})
export class TableSortingComponent {
  @Input('col') currentSortColumn!: string;
  @Output('colChange') currentSortColumnChange = new EventEmitter<string>();
  @Input('dir') currentSortDirection!: string;
  @Output('dirChange') currentSortDirectionChange = new EventEmitter<string>();
  @Input('colName') columnName: string;
  @Input('cb') sortCallback: () => void;

  changeSort(): void {
    if (this.currentSortColumn == this.columnName) {
      if (this.currentSortDirection == 'asc') {
        this.currentSortDirection = 'desc';
      } else {
        this.currentSortDirection = 'asc';
      }
      this.currentSortDirectionChange.emit(this.currentSortDirection);
    } else {
      this.currentSortColumn = this.columnName;
      this.currentSortDirection = 'asc';
      this.currentSortColumnChange.emit(this.currentSortColumn);
      this.currentSortDirectionChange.emit(this.currentSortDirection);
    }
    this.sortCallback();
  }

  isSort(dir: string): boolean {
    return (this.currentSortColumn == this.columnName) &&
      (this.currentSortDirection == dir);
  }
}